import { throttle } from 'lodash';

import { USE_API_MOCKS } from '../env';
import { RESTClientMock, RESTClient } from './client';
import {
  fetchAuditTrialsListMock,
  fetchAuditBusinessProcessesMock,
} from './mocks/auditTrials';
import { AuditTrialType } from '@dynamika-shared/types/auditTrial';
import { API_URL, SERVICE_URL } from './apiDictionary';

import {
  PaginatedArgs,
  PaginatedResponse,
} from '@dynamika-shared/types/general';

export type AuditTrialProps = PaginatedArgs & {
  patientCode?: string;
  patientId?: string;
  clinicalTrialId: string;
  from: string;
  to: string;
  actionBy?: string;
  businessProcess?: string;
  actionType?: string;
  event?: string;
};

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchAuditBusinessProcesses = (clinicalTrialId: string) => {
  if (USE_API_MOCKS) {
    fetchAuditBusinessProcessesMock();
  }

  return api.get<string[]>(`${API_URL.auditBusinessProcesses}`, {
    baseURL: SERVICE_URL.auditLogsService,
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });
};

export const fetchAuditTrialList = throttle(async (args?: AuditTrialProps) => {
  if (USE_API_MOCKS) {
    fetchAuditTrialsListMock(args);
  }
  return api.get<PaginatedResponse<AuditTrialType>>(`${API_URL.auditTrial}`, {
    baseURL: SERVICE_URL.auditLogsService,
    params: {
      patientCode: args?.patientCode,
      
      from: args?.from,
      to: args?.to,
      page: args?.page ? args?.page - 1 : 0,
      size: args?.size ?? 10,
      sort: args?.sort,
      actionBy: args?.actionBy,
      businessProcess: args?.businessProcess,
      actionType: args?.actionType,
      event: args?.event,
    },
    headers: {
      'x-dynamika-clinical-trial-id': args?.clinicalTrialId,
    },
  });
}, 500);
